/* Click Fencing - record the plan on screen BEFORE Add to Cart. 2026-09-14.
 *
 * Pete, Dallas Shores call, 10 Sep 2026: "At the moment, the system records it when you go to
 * add to cart... I've tried to make it happen sooner, but I think we need to record these plans
 * a bit sooner."
 *
 * WHY IT ONLY HAPPENED AT ADD TO CART. The four calculators write a plan to localStorage
 * (ullc_quotes / blade_quotes / flattop_quotes / perfmesh_quotes) only inside
 * proceedToQuotePage, addToCart and addSiteInspectionToCart. assets/cf-plans.js pushes those
 * saved plans to the CRM's click-quote-intake - so a customer who priced a fence and left
 * before pressing the button left nothing behind.
 *
 * WHAT THIS DOES. Reads the live calculator's own quoteBreakdown (the parts list on screen) and,
 * once it is a real priced plan, posts it to click-plan-autosave:
 *   - debounced: 4s after the customer stops touching the calculator, plus a 20s safety tick
 *   - on leaving the page (pagehide / tab hidden), by sendBeacon
 *   - only when the plan actually changed since the last send
 * The server keeps ONE current plan per browser per calculator (an upsert) and creates no
 * contact, task, email or notification. When the browser's cf_visitor_id later lands on a
 * contact (the person identifies themselves), the plan joins that contact in the database.
 *
 * NOTHING HERE MAY SLOW OR BREAK A CALCULATOR. It never calls a calculator method, only reads
 * state; every entry point is in try/catch; sends are fire-and-forget; capped per page view.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://mhzmtafzxeshqqtktbwh.supabase.co/functions/v1/click-plan-autosave';
  var PAGES = {
    '/pages/glass-fencing': 'Frameless',
    '/pages/blade-fence-calculator': 'Blade',
    '/pages/flat-top-fence-calculator': 'FlatTop',
    '/pages/perfmesh-fence': 'PerfMesh'
  };
  var VISITOR_KEY = 'cf_visitor_id';   // the same key assets/cf-plans.js uses - one identity
  var DEBOUNCE_MS = 4000;
  var TICK_MS = 20000;
  var MAX_SENDS = 40;
  var MAX_BODY = 58000;

  try {
    if (window.__cfPlanAutosave) return;
    var path = String(location.pathname || '').replace(/\/+$/, '');
    var CALC = PAGES[path];
    if (!CALC) return;
    // Staff building a quote inside the CRM's embedded calculator are not a customer.
    if (/[?&]crm_embed=1\b/.test(location.search)) return;
    window.__cfPlanAutosave = { calculator: CALC, sends: 0, lastFp: '', lastResult: null };
  } catch (e) { return; }

  var S = window.__cfPlanAutosave;
  var timer = null;

  function visitorId() {
    try {
      var v = localStorage.getItem(VISITOR_KEY);
      if (v) return v;
      v = 'v' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      try { if (window.crypto && crypto.randomUUID) v = crypto.randomUUID(); } catch (e) {}
      localStorage.setItem(VISITOR_KEY, v);
      return v;
    } catch (e) { return ''; }
  }

  function calculator() {
    var gc = window.glassCalculator || window.glassFencingCalculator;
    return gc && gc.state ? gc : null;
  }

  function n(v) { var x = Number(v); return isFinite(x) ? x : null; }

  /* The plan on screen, in the shape the calculators themselves save - or null when there is
     nothing worth keeping yet (no calculator, no priced parts, a zero total). */
  function snapshot() {
    var gc = calculator();
    if (!gc) return null;
    var st = gc.state || {};
    var bd = Array.isArray(st.quoteBreakdown) ? st.quoteBreakdown : [];
    /* PerfMesh's own saved plan and its total leave these out - match it exactly so the draft
       total is the figure the customer sees. */
    if (CALC === 'PerfMesh') {
      bd = bd.filter(function (i) {
        return i && i.category !== 'Spigots & Hardware' && String(i.item || '').indexOf('Hinge Panel') < 0;
      });
    }
    var lines = [], total = 0, fp = [];
    for (var k = 0; k < bd.length; k++) {
      var i = bd[k];
      if (!i || !i.item) continue;
      var qty = n(i.quantity);
      if (!(qty > 0)) continue;
      var tp = n(i.totalPrice);
      if (tp !== null) total += tp;
      lines.push({
        item: String(i.item).slice(0, 200),
        colour: i.colour ? String(i.colour).slice(0, 60) : null,
        sku: i.sku != null && i.sku !== '' ? String(i.sku) : null,
        category: i.category ? String(i.category).slice(0, 80) : null,
        quantity: qty,
        unitPrice: n(i.unitPrice),
        totalPrice: tp,
        variantId: i.variantId != null ? String(i.variantId) : null
      });
      fp.push(i.item + '|' + (i.colour || '') + '|' + qty + '|' + (tp === null ? '' : tp.toFixed(2)));
    }
    total = Math.round(total * 100) / 100;
    if (!lines.length || !(total > 0)) return null;

    var sections = [];
    try {
      var secs = st.sections || {};
      for (var key in secs) {
        if (!Object.prototype.hasOwnProperty.call(secs, key)) continue;
        var s = secs[key] || {};
        if (!s.length) continue;
        sections.push({
          num: parseInt(key, 10) || null,
          length: s.length,
          hasGate: !!s.hasGate,
          gateLength: s.gateLength || null,
          hasRaked: !!s.hasRaked,
          colour: s.postColor || s.meshColor || s.panelColor || s.color || null
        });
      }
    } catch (e) { sections = []; }

    /* 15 Oct 2026 (Pete, Desma Decke: "how can we not see where the gate sits?"). The draft also carries the
       fence LAYOUT now - panels in order with widths, the gap or post after each, gate side - from the same
       builder the "Email me this quote" box uses (window.CF_PLAN_LAYOUT, cf-price-capture.js), so a design
       released from the Click Desk can be drawn in the CRM. The summary fields above are kept as they were
       (the Desk reads colour, length and hasGate from them). Any failure leaves the summary alone. */
    var layoutFp = '';
    try {
      var L = window.CF_PLAN_LAYOUT;
      var full = L && typeof L.sections === 'function' ? L.sections() : null;
      if (Array.isArray(full) && full.length) {
        var merged = sections.map(function (sum) {
          var f = null;
          for (var j = 0; j < full.length; j++) if (String(full[j].num) === String(sum.num)) { f = full[j]; break; }
          if (!f || !Array.isArray(f.panels)) return sum;
          var out = {}, k2;
          for (k2 in f) if (Object.prototype.hasOwnProperty.call(f, k2)) out[k2] = f[k2];
          for (k2 in sum) if (Object.prototype.hasOwnProperty.call(sum, k2) && sum[k2] != null) out[k2] = sum[k2];
          return out;
        });
        // click-plan-autosave drops ALL sections over 25,000 characters, which would cost the Desk its summary
        if (JSON.stringify(merged).length > 24000) throw new Error('layout too big');
        sections = merged;
        // a gate moved or a panel swapped without the parts changing is still a new design
        layoutFp = sections.map(function (x) {
          return (x.panels || []).map(function (p) { return (p.type || '') + p.width; }).join(',') + '/' + (x.gateSide || '') +
            '/' + (x.startGap || 0) + '/' + (x.trailingGaps || []).join(',');
        }).join(';');
      }
    } catch (e) { layoutFp = ''; }

    return {
      fp: CALC + '|' + (st.pricingType || '') + '|' + total.toFixed(2) + '|' + fp.join(';') + '|' + layoutFp,
      total: total, lines: lines, sections: sections,
      pricingType: st.pricingType || null,
      currency: (gc.shopifyData && gc.shopifyData.shop && gc.shopifyData.shop.currency) || 'AUD'
    };
  }

  function send(snap, leaving) {
    try {
      if (S.sends >= MAX_SENDS) return;
      var vid = visitorId();
      if (!vid) return;
      var payload = {
        visitorId: vid, calculator: CALC, pricingType: snap.pricingType, grandTotal: snap.total,
        currency: snap.currency, lines: snap.lines, sections: snap.sections,
        page: location.pathname, device: (window.innerWidth || 0) < 768 ? 'mobile' : 'desktop'
      };
      var body = JSON.stringify(payload);
      if (body.length > MAX_BODY) {
        // too big with the layout: keep the summary fields only, then nothing (as before)
        payload.sections = (snap.sections || []).map(function (x) {
          return { num: x.num, length: x.length, hasGate: x.hasGate, gateLength: x.gateLength, hasRaked: x.hasRaked, colour: x.colour };
        });
        body = JSON.stringify(payload);
      }
      if (body.length > MAX_BODY) { payload.sections = []; body = JSON.stringify(payload); }
      if (body.length > MAX_BODY) return;   // a plan this size is not a real fence; never block on it

      S.sends++;
      S.lastFp = snap.fp;
      // text/plain = a CORS simple request, so no preflight to fail while the page unloads.
      if (navigator.sendBeacon) {
        try {
          if (navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }))) {
            S.lastResult = leaving ? 'beacon (leaving)' : 'beacon';
            return;
          }
        } catch (e) {}
      }
      fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, mode: 'cors' })
        .then(function () { S.lastResult = 'fetch'; })
        .catch(function () { S.lastResult = 'failed'; });
    } catch (e) {}
  }

  function check(leaving) {
    try {
      var snap = snapshot();
      if (!snap || snap.fp === S.lastFp) return;
      send(snap, leaving);
    } catch (e) {}
  }

  function schedule() {
    try {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { timer = null; check(false); }, DEBOUNCE_MS);
    } catch (e) {}
  }

  try {
    ['input', 'change', 'click'].forEach(function (ev) {
      document.addEventListener(ev, schedule, { capture: true, passive: true });
    });
    setInterval(function () { check(false); }, TICK_MS);
    window.addEventListener('pagehide', function () { check(true); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') check(true);
    });
    console.log('[cf-plan-autosave] installed for ' + CALC);
  } catch (e) {}
})();
